<div class="col-size6 t-col-size8 m-col-size4">
  <div class="title">
    {{ 'PROFILE.DEREGISTER_USER.REQUEST.TEXT_1' | translate }}
  </div>
  <div class="subtitle">
    <span class="subtitle subtitle__span">{{
      'PROFILE.DEREGISTER_USER.REQUEST.TEXT_2' | translate
    }}</span>
  </div>

  <div class="subtitle">
    <span class="subtitle subtitle__span subtitle__span--part1">{{ 'PROFILE.DEREGISTER_USER.REQUEST.TEXT_3' | translate
    }}</span>

    <span class="subtitle subtitle__span subtitle__span--part2">{{ 'PROFILE.DEREGISTER_USER.REQUEST.TEXT_3_2' | translate
    }}</span>
  </div>


  <div class="subtitle">
    <span class="subtitle subtitle__span">{{
      'PROFILE.DEREGISTER_USER.REQUEST.TEXT_4' | translate
    }}</span>
  </div>

  <div class="subtitle">
    <span class="subtitle subtitle__span">{{
      'PROFILE.DEREGISTER_USER.REQUEST.TEXT_5' | translate
    }}</span>
  </div>

  <div class="white-box-footer-buttons mapfre-hide-mobile">
    <ion-button
      [disabled]=""
      class="mapfre-hide-tablet"
      color="primary"
      (click)="onContinue()"
    >
      {{
        'PROFILE.DEREGISTER_USER.REQUEST.BTN_TITLE'
          | translate
          | uppercase
      }}
    </ion-button>
    <ion-button
      [disabled]=""
      class="mapfre-hide-desktop"
      size="medium"
      color="primary"
      (click)="onContinue()"
    >
      {{
        'PROFILE.DEREGISTER_USER.REQUEST.BTN_TITLE'
          | translate
          | uppercase
      }}
    </ion-button>
  </div>
  <ion-button
    [disabled]=""
    size="large"
    *ngIf="!ctx.isApp"
    class="mapfre-hide-desktop mapfre-hide-tablet ion-no-margin"
    expand="block"
    color="primary"
    (click)="onContinue()"
  >
    {{
      'PROFILE.DEREGISTER_USER.REQUEST.BTN_TITLE'
        | translate
        | uppercase
    }}
  </ion-button>
</div>
